import {Component} from 'react';
import h from 'react-hyperscript';
import './AnnouncementBar.scss';
import Button from 'Components/Buttons/Buttons';

class AnnouncementBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  componentDidMount() {
    const {checkActive} = this.props;

    if (checkActive) {
      this.setState({
        active: checkActive(),
      });
    }
  }

  componentWillUnmount() {
    if (this.inactiveTimeout) {
      clearTimeout(this.inactiveTimeout);
    }
  }

  handleClick() {
    const {button} = this.props;
    this.setState({active: false});
    this.inactiveTimeout = null;
    if (button.onClick) {
      button.onClick();
    }
  }

  render() {
    const {desc, link, button, className} = this.props;
    const {active} = this.state;
    const activeClass = active ? ' active' : ' inactive';
    const descriptor = className ? ' ' + className : '';
    const anchor = link ? h(Button, {
      type: 'inline',
      external: true,
      to: link.url,
    }, link.text) : null;

    const ctaButton = button ? h(Button, {
      type: 'button button--basic',
      external: 'false',
      onClick: this.handleClick.bind(this),
    }, button.text) : null;

    return (
      h('div', {
        className: 'announcement-bar' + activeClass + descriptor,
      }, [
        h('div', {className: 'container'}, [
          h('p', {className: 'announcement-bar__link'}, [
            desc + ' ',
            anchor,
          ]),
          ctaButton,
        ]),
      ])
    );
  }
}

export default AnnouncementBar;
